export enum ContactMethod {
    EMAIL = "Email",
    SMS = "SMS",
    PHONE = "Phone"
}
